module.exports = __webpack_public_path__ + "static/media/soil.f3f94d69.svg";